import { Text } from '@alefeducation/ui-elements-library-core';
import React from 'react';
import styled from 'styled-components';
import { Role } from '../types';
import {
  RNP_DESCRIPTION_TITLE,
  RNP_PERMISSIONS_TITLE,
} from '../../../utils/constants';

const StyledDetail = styled.div`
  margin-top: 15px;

  padding: 16px 64px 0 30px;
  border-top: 1px solid lightgray;

  > div:first-child {
    margin-bottom: 3px;
  }
`;

const StyledDetailItem = styled(Text)`
  margin-left: 5px;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const StyledPermissionText = styled(Text)`
  align-self: flex-start;
`;

const Details = ({
  descriptionText,
  permissionsText,
}: Pick<Role, 'descriptionText' | 'permissionsText'>) => {
  return (
    <StyledDetail data-testid="rnp-detail">
      <Flex>
        <StyledPermissionText variant="body-large" weight="bold">
          {RNP_DESCRIPTION_TITLE}
        </StyledPermissionText>
        <StyledDetailItem variant="body-large" weight="light">
          {descriptionText}
        </StyledDetailItem>
      </Flex>

      <Flex>
        <StyledPermissionText variant="body-large" weight="bold">
          {RNP_PERMISSIONS_TITLE}
        </StyledPermissionText>
        <StyledDetailItem variant="body-large" weight="light">
          {permissionsText}
        </StyledDetailItem>
      </Flex>
    </StyledDetail>
  );
};

export default Details;
